import { ViewNotificationsRegister, ViewNotificationDataType } from '@ecosystem/newron-client-lib';

const FILTER_DOMAIN_NAME = 'market-portfolio';

const registerViewFilterFunction = (viewFilterFunction: (filterData: ViewNotificationDataType) => void) => {
  ViewNotificationsRegister?.getInstance().register({
    domainName: FILTER_DOMAIN_NAME,
    viewFilterFunction,
  });
};

export { registerViewFilterFunction };
